var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllCouponIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 40.8535V32.1544C21.5 31.1005 22.3622 30.2383 23.4161 30.2383H26.4436",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8454 33.5724V34.5687C42.8454 35.6226 41.9832 36.4848 40.9293 36.4848H23.4161C22.3622 36.4848 21.5 37.3471 21.5 38.4009V56.5848C21.5 57.6387 22.3622 58.5009 23.4161 58.5009H56.9863C58.0402 58.5009 58.9024 57.6387 58.9024 56.5848V33.5724C58.9024 32.5185 58.0402 31.6562 56.9863 31.6562H44.7615C43.7077 31.6562 42.8454 32.5185 42.8454 33.5724Z",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4434 36.5414V23.4736C26.4434 22.4197 27.3056 21.5575 28.3595 21.5575L52.0617 21.5C53.1156 21.5 53.9778 22.3622 53.9778 23.4161V31.6554",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3398 46.3906H52.9634",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3398 52.3477H52.9634",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#7762DF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCouponIcon);
export default __webpack_public_path__ + "static/media/all_coupon_icon.f71907ae1e3b235629eedb0713a06aa7.svg";
export { ForwardRef as ReactComponent };